import React, { useState, useEffect } from 'react';
import './ThankYou.css';

function ThankYou() {
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    // Track successful consultation booking
    if (typeof window.gtag !== 'undefined') {
      // Get UTM parameters if they exist
      const urlParams = new URLSearchParams(window.location.search);
      const utmData = {
        utm_source: urlParams.get('utm_source'),
        utm_medium: urlParams.get('utm_medium'),
        utm_campaign: urlParams.get('utm_campaign'),
        utm_term: urlParams.get('utm_term'),
        utm_content: urlParams.get('utm_content')
      };

      // Track page view with GTM dataLayer
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'page_view',
        page_title: 'Thank You - Consultation Booked',
        page_location: window.location.href
      });

      // Track successful consultation booking as conversion
      if (typeof window.gtag !== 'undefined') {
        window.gtag('event', 'conversion', {
          'send_to': 'AW-17465397731/POpFCI6RsYUbEOOjk4hB',
          'value': 1.0,
          'currency': 'USD',
          'custom_parameters': {
            'source': utmData.utm_source || 'direct',
            'medium': utmData.utm_medium || 'none',
            'campaign': utmData.utm_campaign || 'none',
            'booking_completed': true
          }
        });

        // Track as goal completion
          window.gtag('event', 'purchase', {
          transaction_id: Date.now().toString(),
          value: 1,
          currency: 'USD',
          items: [{
            item_id: 'consultation',
            item_name: 'Consultation Booking',
            category: 'service',
            quantity: 1,
            price: 1
          }]
        });
      }
    }

    // Countdown timer
    const timer = setInterval(() => {
      setCountdown((prevCount) => {
        if (prevCount <= 1) {
          // Redirect to main site
          window.location.href = 'https://rkubeservices.com';
          return 0;
        }
        return prevCount - 1;
      });
    }, 1000);

    // Cleanup timer on component unmount
    return () => clearInterval(timer);
  }, []);

  const handleGoNow = () => {
    window.location.href = 'https://rkubeservices.com';
  };

  return (
    <div className="thank-you-page">
      <div className="thank-you-container">
        <div className="thank-you-content">
          {/* Success Animation */}
          <div className="success-animation">
            <div className="checkmark-circle">
              <div className="checkmark"></div>
            </div>
          </div>

          {/* Main Message */}
          <h1>Thank You!</h1>
          <h2>Your Consultation is Confirmed</h2>
          
          <p className="confirmation-message">
            🎉 <strong>Great choice!</strong> Your consultation with our RKube team has been successfully scheduled.
          </p>

          {/* What Happens Next */}
          <div className="next-steps">
            <h3>What happens next?</h3>
            <div className="steps-list">
              <div className="step-item">
                <div className="step-icon">📧</div>
                <div className="step-text">
                  <strong>Confirmation Email</strong>
                  <span>You'll receive a calendar invite with meeting details</span>
                </div>
              </div>
              <div className="step-item">
                <div className="step-icon">📋</div>
                <div className="step-text">
                  <strong>Preparation Materials</strong>
                  <span>We'll send you a brief questionnaire to maximize your consultation</span>
                </div>
              </div>
              <div className="step-item">
                <div className="step-icon">💬</div>
                <div className="step-text">
                  <strong>Expert Consultation</strong>
                  <span>Our team will discuss your business needs and provide tailored solutions</span>
                </div>
              </div>
            </div>
          </div>

          {/* Value Proposition */}
          <div className="value-proposition">
            <h3>🚀 While you're here...</h3>
            <p>
              Did you know that businesses using RKube's AI-powered bookkeeping save an average of 
              <strong> 20+ hours per month</strong> and reduce accounting costs by <strong>up to 70%</strong>?
            </p>
          </div>

          {/* Redirect Information */}
          <div className="redirect-info">
            <p className="redirect-message">
              Redirecting to our main website in <strong>{countdown}</strong> seconds...
            </p>
            <div className="redirect-actions">
              <button 
                className="btn-primary" 
                onClick={handleGoNow}
              >
                Go Now
              </button>
              <p className="redirect-note">
                Or <a href="https://rkubeservices.com" className="manual-link">click here</a> to visit manually
              </p>
            </div>
          </div>

          {/* Contact Information */}
          <div className="contact-backup">
            <h4>Need to reschedule or have questions?</h4>
            <p>
              Contact us at: <strong>support@rkubeservices.com</strong>
              <br />
              Or visit: <a href="https://rkubeservices.com" target="_blank" rel="noopener noreferrer">rkubeservices.com</a>
            </p>
          </div>

          {/* Social Proof */}
          <div className="social-proof-mini">
            <p className="trust-message">
              ⭐ Trusted by 1000+ businesses • 99% client satisfaction rate
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;
